import { createGenerator } from './create.js';
import config from '../syntax/config/generator.js';

export default createGenerator(config);
